<template>
  <div>
    <el-dialog
      :title="dialog.title"
      :visible.sync="isItVisible"
      width="55%"
      ref="dialogRef"
      :before-close="handleClose"
    >
      <h3>Técnico Responsable</h3>
      <el-form
        :model="dialog"
        :rules="rules[dialog.type]"
        ref="dialogForm"
        label-width="120px"
        label-position="top"
      >
        <el-form-item
          label="Comentario del Log"
          prop="comment"
          v-if="dialog.type !== 'none'"
        >
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="dialog.placeholder"
            v-model="dialog.comment"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          label="Diagnóstico"
          prop="diagnostic"
          v-if="dialog.type == 'close'"
        >
          <el-input
            type="textbox"
            :placeholder="dialog.placeholder"
            v-model="dialog.diagnostic"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          label="Solución Definitiva"
          prop="solution"
          v-if="dialog.type == 'close'"
        >
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="dialog.placeholder"
            v-model="dialog.solution"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          size="mini"
          @click="cancelDialog('dialogForm')"
        >
          Cancelar</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="confirmDialog('dialogForm')"
          v-loading="confirmLoading"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  RULES,
  COMMON_DIALOG
} from "@/views/modules/technical_support/requests/requests";

export default {
  name: "CloseServiceRequestDialog",
  props: {
    isItVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    RequestTaskId: {
      type: String,
      default: "",
      required: true
    },
    RTID: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data() {
    return {
      confirmLoading: false,
      dialog: COMMON_DIALOG,
      rules: RULES
    };
  },
  created() {
    this.dialog = {
      type: "close",
      placeholder: "Porfavor ingrese el porque cerrar.",
      title: `Cerrar Solicitud NO. ${this.RTID}`,
      requestId: this.RTID
    };
  },
  methods: {
    confirmDialog(formName) {
      this.confirmLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("paso la validacion");

          this.confirmLoading = true;

          switch (this.dialog.type) {
            case "close": {
              this.executeAction("/api/serviceRequests/close", {
                RequestId: this.dialog.requestId,
                UserId: this.$store.state.user.user.UserID,
                Comments: this.dialog.comment,
                Diagnostic: this.dialog.diagnostic,
                Solution: this.dialog.solution
              });
              /*if(this.ruleForm.Telefono != "")
              {
                this.executeAction("/api/serviceRequests/close", {
                RequestId: this.dialog.requestId,
                UserId: this.$store.state.user.user.UserID,
                Comments: this.dialog.comment,
                Diagnostic: this.dialog.diagnostic,
                Solution: this.dialog.solution
              });
              this.submitForm("ruleForm");

              }*/
              break;
            }

            default:
              break;
          }
        } else {
          this.dialog.visible = true;
          this.confirmLoading = false;
          this.$message.error("Campos requeridos, accion no realizada!");
          return false;
        }
      });
    },
    executeAction(url, data) {
      this.$http
        .post(url, data, { timeout: 3 * 60 * 1000 })
        .then((resp) => {
          if (url.includes("DeviceActivationNavixy")) this.msg = resp.data;
          else this.msg = "Acción ralizada con éxito";

          this.confirmLoading = false;
          this.dialog.visible = false;
          this.$message({
            type: "success",
            message: this.msg
          });
          this.$emit("UpdateTaskReport");
        })
        .catch((err) => {
          this.confirmLoading = false;
          // this.dialog.visible = false;
          this.$message.error(err.message || "Accion fallida.");
        })
        .finally(() => {
          this.refreshTableSuccess();
          this.confirmLoading = false;
          this.dialog = {
            visible: false,
            requestId: 0,
            comment: "",
            title: "",
            type: "",
            technical: "",
            confirm: {
              loading: false
            },
            request: {}
          };
        });
    },
    cancelDialog() {
      this.$emit("ClosingServiceRequesCloseDialog", false);
    }
  },
  watch: {
    RTID(val) {
      console.log("Cambio RTID", val);
      this.dialog = {
        type: "close",
        placeholder: "Porfavor ingrese el porque cerrar.",
        title: `Cerrar Solicitud NO. ${val}`,
        requestId: val
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>
